import { sources } from "../../../configs/constants";
import { kpis } from "../../../configs/kpis";

export const dimensions = [
  // { id: "global", label: "Global" },
  { id: "regional", label: "Centrale Régionale" },
  { id: "retailer_label", label: "Enseigne" },
  { id: "sector_id", label: "Secteur" },
  { id: "pdc_id", label: "PDC" },
  { id: "location", label: "Emplacement", sources: [sources.CATEGORY, sources.FAMILY, sources.BRAND, sources.PRODUCT] },
  { id: "strate", label: "Strate", sources: [sources.PRODUCT] },
  { id: "category", label: "Catégorie", sources: [sources.CATEGORY, sources.FAMILY, sources.BRAND, sources.PRODUCT] },
  { id: "family", label: "Famille", sources: [sources.FAMILY, sources.BRAND, sources.PRODUCT] },
  { id: "brand", label: "Marque", sources: [sources.BRAND, sources.PRODUCT] },
  { id: "product_ean", label: "Référence", sources: [sources.PRODUCT] },
  { id: "frequency_respect", label: "Respect Fréquence", kpis: [kpis.RESPECT_FREQUENCES] },
  { id: "pdc_cip", label: "CIP" },
  { id: "product_range_properties", label: "Type de MEA", kpis: [kpis.MEA] },
  { id: "action_nature", label: "Action nature", kpis: [kpis.MEA, kpis.PLV, kpis.NB_BRI] },
  { id: "action_type", label: "Action type", kpis: [kpis.MEA, kpis.PLV, kpis.NB_BRI] },
  { id: "typology", label: "Typologie" },
  {
    id: "vendor_fullname",
    label: "Vendeur",
    kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION]
  },
  { id: "vendor_email", label: "Email du vendeur", kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION] },
  { id: "vendor_role", label: "Role du vendeur", kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION] },
  {
    id: "training_family",
    label: "Formation (Famille)",
    kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION]
  },
  {
    id: "training_level",
    label: "Niveau de formation",
    kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION]
  },
  {
    id: "training_date",
    label: "Date de formation",
    kpis: [kpis.NB_VENDEURS, kpis.NIV_FORMATION, kpis.DATE_FORMATION]
  },
  {
    id: "kpi_value_label",
    label: "Valeurs",
    display: kpi => kpi.format === "checkbox" || kpi.format === "radio"
  },
  {
    id: "network_label",
    label: "Réseau",
    //display: kpi => kpi.format === "checkbox" || kpi.format === "radio"
  },
  { id: "global", label: "Global" }
];

export const dimensionsByKpi = kpi => {
  return dimensions.filter(v => {
    let isSourcesOk = false;
    let isKpisOk = false;

    //only pharma
    if (v.id === "pdc_cip" && kpi.client_id && kpi.client_id.indexOf(17) === -1) {
      return false;
    }

    //only DPN
    if (v.id === "typology" && kpi.client_id && kpi.client_id[0] && [11, 3].indexOf(kpi.client_id[0]) === -1 /*kpi.client_id.indexOf(11) === -1*/) {
      return false;
    }

    if (v.sources) {
      for (let i = 0; i < v.sources.length; i++) {
        const source = v.sources[i];
        if (sources.equals(source, kpi.source)) {
          isSourcesOk = true;
          continue;
        }
      }
    } else {
      isSourcesOk = true;
    }

    if (v.kpis) {
      if (v.kpis.indexOf(kpi.id) !== -1) {
        isKpisOk = true;
      }
    } else if (v.display) {
      isKpisOk = v.display(kpi);
      v.label = kpi.long_label
    } else {
      isKpisOk = true;
    }

    return !!(isSourcesOk && isKpisOk);
  });
};

export const mapping = [
  {
    id: "pdc_id",
    label: "PDC"
  },
  {
    id: "pdc_label",
    label: "PDC"
  },
  {
    id: "retailer_label",
    label: "Enseigne"
  },
  {
    id: "regional",
    label: "Centrale régionale"
  },
  {
    id: "sector_label",
    label: "Secteur"
  },
  {
    id: "sector_id",
    label: "Secteur"
  },
  {
    id: "category",
    label: "Catégorie"
  },
  {
    id: "family",
    label: "Famille"
  },
  {
    id: "brand",
    label: "Marque"
  },
  {
    id: "product_label",
    label: "Produit"
  },
  {
    id: "product_ean",
    label: "Référence"
  },
  {
    id: "detenteur",
    label: "Détenteur"
  },
  {
    id: "date",
    label: "Dernière visite"
  },
  {
    id: "dn",
    label: "DN"
  },
  {
    id: "dn_rea",
    label: "DN_rea"
  },
  {
    id: "dn_theo",
    label: "DN_theo"
  },
  {
    id: "value_no_abs",
    label: "Facings"
  },
  {
    id: "facings_theo",
    label: "facings_theo"
  },
  {
    id: "tx_facing",
    label: "tx_facing"
  },
  {
    id: "pdc_dn_rea",
    label: "pdc_dn"
  },
  {
    id: "location",
    label: "Emplacement"
  },
  {
    id: "presence",
    label: "Présence"
  },
  {
    id: "dn_type",
    label: "DN_type"
  },
  {
    id: "property",
    label: "Propriétés"
  },
  {
    id: "user_email",
    label: "Email"
  },
  {
    id: "frequency",
    label: "Fréquence"
  },
  {
    id: "strate",
    label: "strate"
  },
  {
    id: "product_segments",
    label: "Segments"
  },
  {
    id: "typology",
    label: "Typology"
  },
  {
    id: "merch",
    label: "merch"
  },
  {
    id: "pdc_address",
    label: "Adresse"
  },
  {
    id: "pdc_zip_code",
    label: "Zip code"
  },
  {
    id: "pdc_city",
    label: "Ville"
  },
  {
    id: "product_range_properties",
    label: "Type de MEA"
  },
  {
    id: "action_nature",
    label: "Action nature"
  },
  {
    id: "action_type",
    label: "Action type"
  }
];
export const dimensionMappingByKpi = (kpi = {}) => {
  const mappingClone = mapping.map(a => Object.assign({}, a));
  if (kpi.id === kpis.MEA || kpi.id === kpis.PLV || kpi.id === kpis.NB_BRI) {
    let mappingItem = mappingClone.find(v => v.id === "product_range_properties");
    if (mappingItem) {
      mappingItem.label = "Type de MEA";
    }
  }

  return mappingClone;
};

export const getDimensionTitle = dimensionId => {
  const dim = mapping.find(v => v.id === dimensionId) || {};
  return dim.label || "";
};

export const getDimensionLabel = dataset => {
  let dimId = dataset.dim || "";
  let dimValue = dataset.dim_value || "Non renseigné";

  //display pdc_label
  if (dimId === "pdc_id") {
    let dimInfos = dataset.dim_infos || {};
    return dimInfos.pdc_label || "";
  }

  return dimValue;
};



// WEBPACK FOOTER //
// src/modules/stats/summary/dimensions.js